import { render, staticRenderFns } from "./CustomerTypeForm.vue?vue&type=template&id=acf9e806&scoped=true"
import script from "./CustomerTypeForm.vue?vue&type=script&lang=js"
export * from "./CustomerTypeForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acf9e806",
  null
  
)

export default component.exports